export enum MESSAGE_SENDER_TYPE {
  CUSTOMER = 'CUSTOMER',
  BUSINESS = 'BUSINESS',
}
